import React from 'react';

import { ButtonContainer } from './RightArrowButton.styles.js';

const RightArrowButton = (props) => {
  return <ButtonContainer onClick={props.onClick} />;
};

export default RightArrowButton;
